import React from 'react';

import SingleRevision from 'features/submissions/components/atoms/SingleRevision';
import { Box } from 'shared/components/display';
import moduleRevisionCardStyles from 'shared/components/molecules/ModuleRevisionCard/moduleRevisionCardStyles';

import { useCurrentUser } from 'shared/hooks/useCurrentUser';
import { Revision } from 'shared/typings/revisions';

interface Props {
  submissionModuleId: number;
  revision: Revision;
  moduleNum: number;
  brandName: string;
  revisionCount: number;
  toggleRevisionModal: (open: boolean | Function) => void;
}

const ModuleRevisionCard: React.FC<Props> = ({
  revision,
  brandName,
  submissionModuleId,
  revisionCount,
  toggleRevisionModal,
}) => {
  const { isCreator } = useCurrentUser();
  return (
    <Box css={moduleRevisionCardStyles}>
      <Box className="revision-card__body">
        <SingleRevision
          revision={revision}
          brandName={brandName}
          isCreator={isCreator}
          submissionModuleId={submissionModuleId}
          revisionCount={revisionCount}
          toggleRevisionModal={toggleRevisionModal}
        />
      </Box>
    </Box>
  );
};

export default ModuleRevisionCard;
